import React from "react";
import SectionContainer from "../../../Homepage/SectionContainer";
import BreadCrumb from "../../../component/BreadCrumb/BreadCrumb";

import MediumButton from "../../../component/button/MediumButton";
import { Col, Row } from "reactstrap";
import Map from "../../../Homepage/Map";
import SmallPage from "../../../Homepage/SmallPage";
import { events } from "../data.js";
import { Link, useNavigate } from "react-router-dom";
import EventService from "../../../services/EventService.js";
import { useQuery } from "@tanstack/react-query";
import { imageBaseApi } from "../../../services/imageBaseApi.js";
import "../event.css";
const Event = () => {
  const router = useNavigate();

  const fetchData = async () => {
    const response = await EventService.getList();
    console.log(response);
    return response;
  };

  const {
    isPending,
    error,
    data: eventData,
  } = useQuery({
    queryKey: ["events"],
    queryFn: fetchData,
  });
  if (isPending) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  return (
    <>
      <SectionContainer>
        <BreadCrumb
          items={[{ title: "HOME", link: "/" }, { title: "EVENTS" }]}
          instituition={false}
        />
        <Row>
          <Col>
            <h1 className="font-level-4" style={{ marginBottom: "34px" }}>
              UPCOMING EVENTS
            </h1>
          </Col>
        </Row>
        <Row>
          {eventData?.length > 0 ? (eventData
            ?.filter(item => item?.isActive == true)
            ?.map((item, index) => (
              <Row key={index} className="mb-5 justify-content-between gy-3">
                <Col lg={5} sm={12}>
                  <div className="rounded-4 w-100 h-100">
                    <img
                      src={`${imageBaseApi}${item?.thumbnailMedia?.url}`}
                      alt={item.title}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                      className="rounded-4"
                    />
                  </div>
                </Col>
                <Col lg={6} sm={12} className="me-4">
                  <h1 className="blog-title lh-1 ">{item?.name}</h1>
                  <p className="country-paragraph-text my-4" >{item?.description
                    ?.split(" ")
                    ?.slice(0, 25)
                    ?.join(" ")}</p>
                  <div className="mt-5" onClick={() => router(`/events/${item?.slug}`)}>

                    <MediumButton label="SEE DETAILS" career={true} fill="#fff" textColor="#7e1790" />
                  </div>
                </Col>
              </Row>
            ))) : <h1 className="country-paragraph-text">There are no upcoming events at the moment.</h1>}
        </Row>
      </SectionContainer>

      <hr className="line" />
      <SectionContainer>
        <Map />
        <hr className="line-style-testprep" />
        <SmallPage countryPage={true} />
      </SectionContainer>
    </>
  );
};

export default Event;
